import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faX } from '@fortawesome/free-solid-svg-icons';
import OtherDetails from '../Components/OtherDetails';
import Address from '../Components/Address';
import ContactPersons from '../Components/ContactPersons';
import BankDetails from '../Components/BankDetails';
import Brands from '../Components/Brands';
import { Loader ,Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import { decryptData } from '../../utils/storageCrypto';

function NewVendor() {
  const navigate = useNavigate();
  const [showOtherDetails, setShowOtherDetails] = useState(true);
  const [showAddress, setShowAddress] = useState(false);
  const [showContactPersons, setShowContactPersons] = useState(false);
  const [showBrands,setShowBrands] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
const [popupMessage, setPopupMessage] = useState('');
const [popupType, setPopupType] = useState('');
const [retryFunction, setRetryFunction] = useState(null);
const [isLoading, setIsLoading] = useState(null);
const [errors, setErrors] = useState({ email:'', mobile_number: '',gstin: '', pan: '', account_number: '' });
const RETRY_LIMIT = 3; // Maximum number of retries
const [retryCount, setRetryCount] = useState(0); // Track retry 
const [imagePreview, setImagePreview] = useState(null);
const [image,setImage] = useState(null);
const [roles,setRoles] = useState([])
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  const [data, setData] = useState({
    name: '',
    company_name: '',
    state: '',
    vendor_type:'',
    roleId:'',
    email: '',
    mobile_number: '',
    image: '',
    is_quickbuy: false,
  });

  const [otherDetails, setOtherDetails] = useState({
    gstin: '',
    pan: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
  });


  const [address, setAddress] = useState({
    address: '',
    city: '',
    state: '',
    pincode: '',
  });

  const [contactPersons, setContactPersons] = useState([
    { name: '', email: '', mobile_number: '', designation: '' }
  ]);

  const [brands, setBrands] = useState([
    { name: '', image: '', video: '' }
  ]);

  const [bankDetails, setBankDetails] = useState({
    bank_name: '',
    bank_IFSC: '',
    account_number: '',
    reEnteraccountnumber: '', // Add this

    account_holder_name: ''
  });

useEffect(() => {
  fetchVendorRoles();
}, []); 


  const handleChange = (e) => {
    const { name, value } = e.target;

  setErrorMessages((prev) =>
  prev.filter((msg) => !msg.toLowerCase().includes(name.replace("_", " ")))
);

    // General validation for all fields
    if (name === 'mobile_number') {
      if (value.length > 10) {
        return; 
      } 
      if (value.length === 1 && !['6','7','8','9'].includes(value)) {
        setErrors((prevState) => ({ 
          ...prevState, 
          mobile_number: 'Mobile number must start with 6, 7, 8 or 9' 
        }));
        return;
      }
      if (!/^[0-9]*$/.test(value)) {
        return;
      }
      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      if (value.length < 10 && value.length > 0) {
        setErrors((prevState) => ({ ...prevState, mobile_number: 'Enter 10 Digits Mobile Number please' }));
      } else {
        setErrors((prevState) => ({ ...prevState, mobile_number: '' }));
      }
    }
  
    if (name === 'email') {
      if (value === '') {
        setErrors((prevState) => ({ ...prevState, email: '' })); // Clear error message if email field is empty
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          setErrors((prevState) => ({ ...prevState, email: 'Please enter a valid email address' }));
        } else {
          setErrors((prevState) => ({ ...prevState, email: '' }));
        }
      }
      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  
    // Handle changes for other fields
    if (name === 'name' || name === 'company_name'|| name === 'vendor_type') {
      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    if(name === 'is_quickbuy') {
      setData((prevState) => ({
        ...prevState,
        [name]: !prevState.is_quickbuy,
      }));
    }
  };
  
  

  const handleChangeOtherDetails = (e) => {
  const { name, value } = e.target;

  setErrorMessages((prev) =>
  prev.filter((msg) => {
    const text = msg.toLowerCase();

    if (name === "gstin") return !text.includes("gst");
    if (name === "pan") return !text.includes("pan");

    return !text.includes(name.replace("_", " "));
  })
);

  // Prevent GSTIN from exceeding 15 characters
  if (name === "gstin" && value.length > 15) {
    return;
  }

  // Prevent PAN from exceeding 10 characters
  if (name === "pan" && value.length > 10) {
    return;
  }

  // Validate GSTIN
  if (name === "gstin") {
    if (value === "") {
      // GSTIN cleared → reset PAN too
      setErrors((prev) => ({ ...prev, gstin: "" }));
      setOtherDetails((prev) => ({ ...prev, gstin: "", pan: "" }));
      return;
    }

    const gstinRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    if (gstinRegex.test(value)) {
      const panNumber = value.substring(2, 12); // PAN inside GST
      setErrors((prev) => ({ ...prev, gstin: "" }));
      setOtherDetails((prev) => ({
        ...prev,
        gstin: value,
        pan: panNumber, // ✅ auto-populate PAN
      }));
        setErrorMessages((prev) =>
    prev.filter((msg) => !msg.toLowerCase().includes("pan"))
  );
    } else {
      setErrors((prev) => ({ ...prev, gstin: "Invalid GSTIN format" }));
      setOtherDetails((prev) => ({ ...prev, gstin: value, pan: "" })); // ❌ reset PAN
    }
    return;
  }

  // Validate PAN (only if user edits manually)
  if (name === "pan") {
    if (value === "") {
      setErrors((prev) => ({ ...prev, pan: "" }));
    } else {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!panRegex.test(value)) {
        setErrors((prev) => ({ ...prev, pan: "Invalid PAN format" }));
      } else {
        setErrors((prev) => ({ ...prev, pan: "" }));
      }
    }
  }

  // Default update
  setOtherDetails((prev) => ({ ...prev, [name]: value }));
};


  const handleDropdownChange = (value) => {
    setOtherDetails((prevDetails) => ({
      ...prevDetails,
      state: value,
    }));
  };

  const handleAddressDropdownChange = (value) => {
    setAddress((prevDetails) => ({
      ...prevDetails,
      state: value,
    }));
  }; 

  const handleChangeAddress = (e) => {
    const { name, value } = e.target;
    setAddress((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleChangeContact = (updatedContacts) => {
    setContactPersons(updatedContacts);
  };

  const handleChangeBrand = (updatedBrands) => {
    setBrands(updatedBrands);
  };

  const addContactPerson = () => {
    setContactPersons([...contactPersons, { name: '', email: '', mobile_number: '', designation: '' }]);
  };

  const addBrand = () => {
    setBrands([...brands, { name: '', image: '', video: '' }]);
  };

  const removeContactPerson = (index) => {
    const updatedContacts = contactPersons.filter((_, i) => i !== index);
    setContactPersons(updatedContacts);
  };

  const removeBrand = (index) => {
    const updatedBrands = brands.filter((_, i) => i !== index);
    setBrands(updatedBrands);
  };

  const handleChangeBankDetails = (e) => {
    const { name, value } = e.target;
   
    setBankDetails(prevState => ({
      ...prevState,
      [name]: value
    }));
  
    // Validate account numbers match
    if (name === 'reEnteraccountnumber') {
      if (value !== bankDetails.account_number) {
        setErrors(prev => ({
          ...prev,
          account_number: 'Account numbers do not match'
        }));
      } else {
        setErrors(prev => ({
          ...prev,
          account_number: ''
        }));
      }
    }
  
    if (name === 'account_number') {
      if (bankDetails.confirm_account_number && value !== bankDetails.confirm_account_number) {
        setErrors(prev => ({
          ...prev,
          account_number: 'Account numbers do not match'
        }));
      } else {
        setErrors(prev => ({
          ...prev,
          account_number: ''
        }));
      }
    }
  };
  
  
 /*  const handleSubmit = async (attempt = 1) => {
    const errorMessages = [];
    
    // Validate name
    if (!data.name) {
      errorMessages.push('Enter the Name of your vendor.');
    }
    
    // Validate mobile number
    if (data.mobile_number) {
      if (data.mobile_number.length !== 10 || !/^[0-9]+$/.test(data.mobile_number)) {
        errorMessages.push('Enter 10 Digits Mobile Number please.');
      }
    }
  
    // Validate email
    if (data.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.email)) {
        errorMessages.push('Please enter a valid email address.');
      }
    }  
    
    // Validate GSTIN
    if (!otherDetails.gstin) {
      errorMessages.push('Please enter the GST.');
    } else {
      const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gstinRegex.test(otherDetails.gstin)) {
        errorMessages.push('Invalid GSTIN format.');
      }
    }
  
    // Validate PAN
    if (!otherDetails.pan) {
      errorMessages.push('Please enter the PAN.');
    } else {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!panRegex.test(otherDetails.pan)) {
        errorMessages.push('Invalid PAN format.');
      }
    }
    
    if (bankDetails.bank_IFSC && bankDetails.bank_IFSC.length !== 11) {
      errorMessages.push('IFSC code must be 11 characters');
    }
    if (errorMessages.length > 0) {
      setErrorMessages(errorMessages);
      return;
    }

    if (errorMessages.length > 0) {
      setErrorMessages(errorMessages);
      return;
    }
    
    setIsLoading(true);
    setIsSaving(true);
    
    try {
      const token = sessionStorage.getItem('token');
      const saveUrl = `${fetchUrl}vendor/create-vendor`;
    
      const addressString = `${address.address} ${address.city} ${address.state} ${address.pincode}`;
      const requestData = {
        ...data,
        vendor_status: 3,
        gstin: data.gstin || otherDetails.gstin,
        pan: data.pan || otherDetails.pan,
        city: data.city || otherDetails.city,
        state: data.state || otherDetails.state,
        address: addressString,
        vendorContacts: JSON.stringify(await handleVendorContacts(contactPersons)),
        bank_name: bankDetails.bank_name,
        pincode: address.pincode,
        bank_IFSC: bankDetails.bank_IFSC,
        account_number: bankDetails.account_number,
        account_holder_name: bankDetails.account_holder_name,
        organizationId: sessionStorage.getItem('organizationId'),
        roleId: 7,
      };
  
      const formData = new FormData();
      Object.keys(requestData).forEach(key => {
        if (key !== 'image') {
          formData.append(key, requestData[key]);
        }
      });
      
      if (image) {
        formData.append('image', image);
      }
    
      const response = await fetch(saveUrl, {
        method: 'POST',
        headers: {
          'x-token': token,
        },
        body: formData
      });
    
      const responseData = await response.json();
    
      if (responseData.status === 400) {
        // Handle specific error messages for PAN and GSTIN
        setIsLoading(false);
        setIsSaving(false);
        setPopupMessage(responseData.message);
        setPopupType('400');
        setShowPopup(true);
        return;
      }
    
      if (responseData.status === 200 || responseData.status === 201) {
        setIsSaving(false);
        setIsLoading(false); 
        setPopupMessage(responseData.message); 
        setPopupType('200or201');
        setShowPopup(true)
        setTimeout(() => {
          setShowPopup(false);
          navigate('/bb/app/purchases/vendordetails', { state: { VendorData: responseData.data.vendor } });
        }, 3000);
        setData(prevData => ({
          ...prevData,
          image: responseData.data.vendor.image
        }));
      } else if (responseData.status === 204) {
        setIsSaving(false);
        setPopupMessage(responseData.message);
        setPopupType('204');
        setIsLoading(false);
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
          navigate('/bb/app/purchases/vendordetails', { state: { VendorData: responseData.data.vendor } });
        }, 3000);
      } else if (responseData.status === 500) {
        setIsSaving(false);
        setIsLoading(false);
        setRetryFunction(() => handleSubmit);
        setPopupMessage(responseData.message);
        setPopupType('500');
        setShowPopup(true);
      } else {
        setIsLoading(false);
        setIsSaving(false);
        setPopupMessage(responseData.message);
        setPopupType(`${responseData.status}`);
        setShowPopup(true);                         
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
    
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => handleSubmit(attempt + 1), 1000);
      } else {
        setIsSaving(false);
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleSubmit(attempt));
      }
    } finally {
      setErrorMessages([]);
    }
  }; */

  const handleSubmit = async (attempt = 1) => {
  const errorMessages = [];
  
  // Validate name
  if (!data.name) {
    errorMessages.push('Enter the Name of your vendor.');
  }
  
  // Validate mobile number
  if (data.mobile_number) {
    if (data.mobile_number.length !== 10 || !/^[0-9]+$/.test(data.mobile_number)) {
      errorMessages.push('Enter 10 Digits Mobile Number please.');
    }
  }

  // Validate email
  if (data.email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      errorMessages.push('Please enter a valid email address.');
    }
  }  
  
  // Validate GSTIN
  if (!otherDetails.gstin) {
    errorMessages.push('Please enter the GST.');
  } else {
    const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gstinRegex.test(otherDetails.gstin)) {
      errorMessages.push('Invalid GSTIN format.');
    }
  }

  // Validate PAN
  if (!otherDetails.pan) {
    errorMessages.push('Please enter the PAN.');
  } else {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(otherDetails.pan)) {
      errorMessages.push('Invalid PAN format.');
    }
  }
  
  if (bankDetails.bank_IFSC && bankDetails.bank_IFSC.length !== 11) {
    errorMessages.push('IFSC code must be 11 characters');
  }
  
  if (errorMessages.length > 0) {
    setErrorMessages(errorMessages);
    return;
  }
  
  setIsLoading(true);
  setIsSaving(true);
  
  try {
   const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);
    const saveUrl = `${fetchUrl}vendor/create-vendor`;
  
    //const addressString = `${address.address} ${address.city} ${address.state} ${address.pincode}`;
      const addressString = `${otherDetails.address} ${otherDetails.city} ${otherDetails.state} ${otherDetails.pincode}`;

    const requestData = {
      ...data,
      vendor_status: 3,
      gstin: data.gstin || otherDetails.gstin,
      pan: data.pan || otherDetails.pan,
      city: data.city || otherDetails.city,
      state: data.state || otherDetails.state,
      address: addressString,
      vendorContacts: JSON.stringify(await handleVendorContacts(contactPersons)),
      //brands:brands,
      bank_name: bankDetails.bank_name,
      pincode: otherDetails.pincode,
      bank_IFSC: bankDetails.bank_IFSC,
      account_number: bankDetails.account_number,
      account_holder_name: bankDetails.account_holder_name,
      organizationId: organizationId,
      roleId: 7,
    };

    console.log(requestData)

    const formData = new FormData();
    Object.keys(requestData).forEach(key => {
      if (key !== 'image') {
        formData.append(key, requestData[key]);
      }
    });
    
    if (image) {
      formData.append('image', image);
    }

    if(brands){
      // ✅ ADD THIS
      formData.append("brands", JSON.stringify(brands));
        brands.forEach((brand, index) => {
        if (brand.image instanceof File) {
          formData.append(`brand_image_${index}`, brand.image);
        }
      });
    }

    // Add timeout controller
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second 
    
    console.log(formData)
  
    const response = await fetch(saveUrl, {
      method: 'POST',
      headers: {
        'x-token': token,
      },
      body: formData,
      signal: controller.signal // Add abort signal
    });

    clearTimeout(timeoutId); // Clear timeout if response received

    
    const responseData = await response.json();
    console.log('Response Data:', responseData);
  
    if (responseData.status === 400) {
      // Handle specific error messages for PAN and GSTIN
      setIsLoading(false);
      setIsSaving(false);
      setPopupMessage(responseData.message);
      setPopupType('400');
      setShowPopup(true);
      return;
    }
  
    if (responseData.status === 200 || responseData.status === 201) {
      setIsSaving(false);
      setIsLoading(false); 
      setPopupMessage(responseData.message); 
      setPopupType('200or201');
      setShowPopup(true)
      setTimeout(() => {
        setShowPopup(false);
        navigate('/bb/app/purchases/vendordetails', { state: { VendorData: responseData.data.vendor } });
      }, 3000);
      setData(prevData => ({
        ...prevData,
        image: responseData.data.vendor.image
      }));
    } else if (responseData.status === 204) {
      setIsSaving(false);
      setPopupMessage(responseData.message);
      setPopupType('204');
      setIsLoading(false);
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
        navigate('/bb/app/purchases/vendordetails', { state: { VendorData: responseData.data.vendor } });
      }, 3000);
    } else if (responseData.status === 500) {
      setIsSaving(false);
      setIsLoading(false);
      setRetryFunction(() => handleSubmit);
      setPopupMessage(responseData.message);
      setPopupType('500');
      setShowPopup(true);
    } else {
      setIsLoading(false);
      setIsSaving(false);
      setPopupMessage(responseData.message);
      setPopupType(`${responseData.status}`);
      setShowPopup(true);                         
    }
  } catch (error) {
    console.error('Failed to fetch:', error);
    setIsSaving(false);
    setIsLoading(false);

    // Handle timeout specifically - don't retry as data might have been created
    if (error.name === 'AbortError') {
      setPopupMessage('Request timed out. Please check if vendor was created before retrying.');
      setPopupType('500');
      setShowPopup(true);
      // Don't set retry function for timeout - prevents duplicate creation
      return;
    }

    // Handle JSON parsing errors - data might have been created
    if (error.message.includes('JSON') || error.name === 'SyntaxError') {
      setPopupMessage('Response error. Please check if vendor was created before retrying.');
      setPopupType('500');
      setShowPopup(true);
      // Don't set retry function for parsing errors
      return;
    }

    // Only retry on actual network errors (not timeout or parsing errors)
    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1);
      setIsSaving(true); // Keep loader showing during retry
      setIsLoading(true); // Keep main loader showing during retry
      setTimeout(() => handleSubmit(attempt + 1), 8000); // 8 seconds
    } else {
      setPopupMessage('Network error occurred. Please verify if vendor was created before retrying.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleSubmit(1)); // Reset attempt count for manual retry
    }
  } finally {
    setErrorMessages([]);
  }
};


  const handleVendorContacts = (contacts) => {
    if (contacts.length > 0) {
      const MobileNumberAvailableContacts = contacts
        .filter(contact => contact.mobile_number && contact.mobile_number.trim() !== '')
        .map(contact => ({
          name: contact.name,
          email: contact.email,
          mobile_number: contact.mobile_number,
          designation: contact.designation
        }));
      
      return MobileNumberAvailableContacts;
    }
    return [];
  }
  
  

  if (isLoading) {
    return <Loader/>;
  }
  const handleCloseError = () => {
    setErrorMessages([]);
  };

  const closePopup = () => {
    setShowPopup(false);
  };
  
  const Retry = async () => {

    setIsLoading(true); // Show loader
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction();
      }
      setIsLoading(false); // Hide loader after retry
    }, 5000); // 5-second delay
    setShowPopup(false);
  };
  
  const BackToLoginPage = () => {
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };

  const handleCancel = () => {
    setShowCancelPopup(true);
  }
  const handleStayHere = () => {
    setShowCancelPopup(false);
  }

  const handleLeave = () => {
    navigate(-1);
  }
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      setImage(file)
    }
  };

  async function fetchVendorRoles() {
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/admin/get-all-vendor-roles `, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch vendor roles");
    }

    const data = await response.json();
    console.log("Vendor Roles:", data.roles);
    setRoles(data.roles)
    //return data.roles;
  } catch (error) {
    console.error("Error fetching vendor roles:", error);
  }
}


  return (
    <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
      <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-lg font-semibold">New Vendor</h1>
                  {/* <button className="text-white px-1 py-1 rounded-md">
                    <FontAwesomeIcon icon={faX} className="text-md text-[#F7525A] cursor-pointer" />
                  </button> */}
                </div>
              </div>
              {errorMessages.length > 0 && (
                <div className="flex justify-between items-center  px-auto py-3  bg-[#fddcde]  rounded-md">
                  <div className="px-6 flex flex-col justify-start items-start">
                    {errorMessages.map((errorMessage, index) => (
                      <span key={index} className="text-sm">
                         •   {errorMessage}
                      </span>
                    ))}
                  </div>
                  <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                    onClick={handleCloseError}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                  </button>
                  </div>
                </div>
              )}
              <div className="flex flex-col justify-start items-start w-full flex-grow h-80 overflow-y-auto">
                <div className="w-full flex flex-col justify-start items-start px-4">
                <div className='w-full flex flex-row'>
                <div className="flex flex-col w-full">

                    {/* Company Name Label and Input */}
                    <div className="w-full flex flex-row items-center mb-4 space-x-10 mt-5">
{/*                     <label htmlFor="companyName" className="block text-sm font-regular text-gray-700 w-1/6">
                      Company Name
                    </label> */}
                    <label htmlFor="companyName" className="block text-sm font-regular text-gray-700 w-1/6">
                      Business Name
                    </label>
                    <input
                      type="text"
                      id="companyName"
                      name="company_name"
                      value={data.company_name}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                  </div>

                  {/* Vendor Name Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-10 mt-5">
{/*                     <label htmlFor="name" className="block text-sm font-regular text-[#e54643] w-1/6">
                      Vendor Name<span className="text-red-500">*</span>
                    </label> */}
                    <label htmlFor="name" className="block text-sm font-regular text-[#e54643] w-1/6">
                      Owner Name<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={data.name}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                  </div>


                  {/* Vendor Type Dropdown */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-10 mt-5">
                    <label htmlFor="vendortype" className="block text-sm font-regular text-gray-700 w-1/6">
                      Vendor Type
                    </label>
                    <select
                      id="vendortype"
                      name="vendor_type"
                      value={data.vendor_type}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    >
                      <option value="">Select Vendor Type</option>
                      <option value="Manufacturer">Manufacturer</option>
                      <option value="Distributor">Distributor</option>
                      <option value="Whole Saler">Whole Saler</option>
                      <option value="Dealer">Dealer</option>
                      <option value="Retailer">Retailer</option>
                      <option value="Stockist">Stockist</option>
                      {/* Add more options as needed */}
                    </select>
                  </div>


            {data.vendor_type !== "Manufacturer" && (<div className="w-full flex flex-row items-center mb-4 space-x-10 mt-5">
              <label
                htmlFor="roleId"
                className="block text-sm font-regular text-gray-700 w-1/6"
              >
                Role
              </label>
              <select
                id="roleId"
                name="roleId"
                value={roles.roleId}   // <-- controlled value from state
                onChange={handleChange}
                className="w-1/3 outline-none block rounded-md border border-gray-300 
                          hover:border-blue-500 focus:border-blue-500 focus:ring 
                          focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
              >
                <option value="">Select Role</option>
                {roles.map((role) => (
                  <option key={role.roleId} value={role.roleId}>
                    {role.roleName}
                  </option>
                ))}
              </select>
            </div>)}


                   {/* Quick Buy Vendor Checkbox */}
        <div className="w-full flex flex-row items-center mb-4 space-x-10 mt-5">
{/*           <label className="block text-sm font-regular text-gray-700 w-1/6">
            Quick Buy Vendor
          </label> */}
          <label className="block text-sm font-regular text-gray-700 w-1/6">
            Direct Seller
          </label>
          <div className="w-1/3 flex items-center space-x-6">
            {/* Yes Option */}
            <label className="flex items-center cursor-pointer">
              <div className="relative">
                <input
                  type="radio"
                  name="is_quickbuy"
                  value="true"
                  checked={data.is_quickbuy === true}
                  onChange={(e) => handleChange({
                    target: {
                      name: 'is_quickbuy',
                      value: e.target.value === 'true'
                    }
                  })}
                  className="sr-only"
                />
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${
                  data.is_quickbuy === true 
                    ? 'border-blue-500 bg-blue-500' 
                    : 'border-gray-300 bg-white hover:border-blue-400'
                }`}>
                  {data.is_quickbuy === true && (
                    <div className="w-2 h-2 rounded-full bg-white"></div>
                  )}
                </div>
              </div>
              <span className="ml-2 text-sm text-gray-700">Yes</span>
            </label>

            {/* No Option */}
            <label className="flex items-center cursor-pointer">
              <div className="relative">
                <input
                  type="radio"
                  name="is_quickbuy"
                  value="false"
                  checked={data.is_quickbuy === false}
                  onChange={(e) => handleChange({
                    target: {
                      name: 'is_quickbuy',
                      value: e.target.value === 'true'
                    }
                  })}
                  className="sr-only"
                />
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${
                  data.is_quickbuy === false 
                    ? 'border-blue-500 bg-blue-500' 
                    : 'border-gray-300 bg-white hover:border-blue-400'
                }`}>
                  {data.is_quickbuy === false && (
                    <div className="w-2 h-2 rounded-full bg-white"></div>
                  )}
                </div>
              </div>
              <span className="ml-2 text-sm text-gray-700">No</span>
            </label>
          </div>
        </div>

                   {/* Company Name Label and Input */}
                   <div className="w-full flex flex-row items-center mb-4 space-x-10 mt-5">
                    <label htmlFor="email" className="block text-sm font-regular text-gray-700 w-1/6">
                      Email
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      value={data.email}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                  </div>

                   {/* Company Name Label and Input */}
                   <div className="w-full flex flex-row items-center mb-4 space-x-10 mt-5">
{/*                     <label htmlFor="mobile" className="block text-sm font-regular text-gray-700 w-1/6">
                      Mobile
                    </label> */}
                    <label htmlFor="mobile" className="block text-sm font-regular text-gray-700 w-1/6">
                      Contact Number
                    </label>
                    <input  type="text" id="mobile" name="mobile_number"
                      value={data.mobile_number}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.mobile_number && <p className="text-red-500 text-sm">{errors.mobile_number}</p>}
                  </div>
                  </div>
                  <div className='w-1/2 justify-start items-start mt-5'>

                  {/* Logo Upload Section */}
                  <div className=" w-1/2 h-36 w-40 border-2 border-dashed border-gray-300 rounded-lg flex justify-center items-center relative">
                <input
                  type="file"
                  id="itemImage"
                  accept="image/*"
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  onChange={handleImageUpload}
                />
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="w-32 h-28 object-cover rounded-lg"
                  />
                ) : (
                  <div className="text-gray-400 text-center text-sm">Click to upload image</div>
                )}
              </div>
              </div>
              </div>



                  <div className='flex w-full items-center border-b'>
                    <div className="w-full flex flex-row space-x-2">
                      <button
                        className={`w-1/6 p-2 text-sm ${showOtherDetails ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(true);
                          setShowAddress(false);
                          setShowContactPersons(false);
                          setShowBankDetails(false);
                          setShowBrands(false)
                        }}
                      >
                        Business Details
                      </button>
                      <button
                        className={`w-1/6 p-2 text-sm ${showBankDetails ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(false);
                          setShowContactPersons(false);
                          setShowBankDetails(true);
                          setShowBrands(false)
                        }}
                      >
                        Bank Details
                      </button>
{/*                       <button
                        className={`w-1/6 p-2 text-sm ${showAddress ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(true);
                          setShowContactPersons(false);
                          setShowBankDetails(false);
                        }}
                      >
                        Address
                      </button> */}
                      <button
                        className={`w-1/6 p-2 text-sm ${showBrands ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(false);
                          setShowContactPersons(false);
                          setShowBrands(true)
                          setShowBankDetails(false);
                        }}
                      >
                        Brands
                      </button>
                      <button
                        className={`w-1/6 p-2 text-sm ${showContactPersons ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(false);
                          setShowContactPersons(true);
                          setShowBankDetails(false);
                          setShowBrands(false)
                        }}
                      >
                        Contact Persons
                      </button>
                    </div>
                  </div>

                  {/* Other Details Section */}
                  {showOtherDetails &&  <OtherDetails
          gstin={otherDetails.gstin}
          pan={otherDetails.pan}
          address={otherDetails.address}
          city={otherDetails.city}
          state={otherDetails.state}
          pincode={otherDetails.pincode}
          onChange={handleChangeOtherDetails}
          errors={errors}
          updateState={handleDropdownChange}
        />}

                  {/* Address Section */}
{/*                   {showAddress && <Address
          address={address.address}
          city={address.city}
          state={address.state}
          pincode={address.pincode}
          onChange={handleChangeAddress}
          updateAddressState={handleAddressDropdownChange}
        />} */}

                  {/* Contact Persons Section */}
                  {showContactPersons && <ContactPersons
                  contactPersons={contactPersons}
                  onChange={handleChangeContact}
                  addContactPerson={addContactPerson}
                  removeContactPerson={removeContactPerson}
                  roles={roles}
                   showRole={true}
                />
                }

                {/* Brands Section */}
                  {showBrands && <Brands
                  brands={brands}
                  onChange={handleChangeBrand}
                  addBrand={addBrand}
                  removeBrand={removeBrand}
                />
                }

                 {/* Contact Persons Section */}
                 {showBankDetails && <BankDetails
                    account_holder_name={bankDetails.account_holder_name}
                    bank_name={bankDetails.bank_name}
                    bank_branch={bankDetails.bank_branch}
                    bank_IFSC={bankDetails.bank_IFSC}
                    account_number={bankDetails.account_number}
                    onChange={handleChangeBankDetails}
                    errors={errors}

                  />}


                </div>
                </div>

                <div className="mt-5 w-full">
                  <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
                  <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
    <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md inline-flex items-center" onClick={handleSubmit}>
      <span>Save</span>
      {isSaving && <Spinner />}
    </button>
    <button  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}
        onClick={handleCancel}>
      Cancel
    </button>
  </div>
                </div>

              </div>
            </div>
        </div>
      </div>

{showCancelPopup && (
    <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md font-semibold">
    <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500 mr-4 " />
      Leave this page?</h2>
      <button onClick={handleStayHere} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4 '>
    <div className="w-full items-center p-5">
      <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
      If you leave, your unsaved changes will be discarded.
      </label>
    </div>  
  </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
        <button className="px-2 py-1 bg-[#408dfb] border-[#f7525a] text-white rounded-md" onClick={handleStayHere}>
  Stay Here  {isSaving && (
      <Spinner/>
    )}
  </button>
          <button onClick={handleLeave} 
          className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50  px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">
            Leave & Discard Changes</button>
        </div>
      </div>
    </div>
  </div>
)}
      {showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}
    </div>
  );
}

export default NewVendor;
